// extracted by mini-css-extract-plugin
export default {"walletBtn":"MultiWalletButton_walletBtn__mDUw5"};